// extracted by mini-css-extract-plugin
export var modal = "_by-0";